export const formatDurationFromMinutes = (minutes?: number) => {
  if (minutes === undefined) return '';

  const h = Math.floor(minutes / 60);
  const m = minutes % 60;

  if (h === 0) return `${m} minute(s)`;
  if (m === 0) return `${h} hour(s)`;

  return `${h} hour(s) ${m} minute(s)`;
};
